// extracted by mini-css-extract-plugin
module.exports = {"ProfileModule":"IoW7LDAR","paper":"_1jKV8kyk","header":"_3MsdqUzM","title":"_1wEWg4ri","footer":"_2ZDV9vKB"};